// extracted by mini-css-extract-plugin
export default {"recipeForm":"RecipeForm_recipeForm__WU4EX"};